import { ListingComponentState } from 'types/store/reducers/ui';

import { getIds } from 'store/utils';
import { SessionActions } from 'types/store/actions/sessions';
import { SessionActionTypes } from 'types/store/actions/constants';

interface SessionComponentState extends ListingComponentState {
  activeSessionIds: (string | number)[];
}

export const initialState: SessionComponentState = {
  activeSessionIds: [],
  ids: [],
  hasMore: false,
  isLoading: false,
  page: 1,
  totalCount: 0,
};

export default (
  state = initialState,
  action: SessionActions
): SessionComponentState => {
  switch (action.type) {
    case SessionActionTypes.RESET:
      return initialState;

    case SessionActionTypes.LIST_SUCCESS: {
      const { records, perPage, totalCount, page } = action.payload;

      const activeSessions = records.filter(rec => rec.status !== 'cancelled');
      const hasMore = perPage * page < totalCount;

      const activeIds = getIds(activeSessions);
      const allIds = getIds(records);

      // NOTE: If we're on a first page, we have to clear all previous ids
      return {
        ...state,
        activeSessionIds: [
          ...(page === 1 ? [] : state.activeSessionIds),
          ...activeIds,
        ],
        ids: [...(page === 1 ? [] : state.ids), ...allIds],
        totalCount,
        page,
        hasMore,
      };
    }
    case SessionActionTypes.SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    }
    default:
      return state;
  }
};
